import { render, staticRenderFns } from "./ActivityIdea.vue?vue&type=template&id=7bb135d1&scoped=true&"
import script from "./ActivityIdea.vue?vue&type=script&lang=js&"
export * from "./ActivityIdea.vue?vue&type=script&lang=js&"
import style0 from "./ActivityIdea.vue?vue&type=style&index=0&id=7bb135d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb135d1",
  null
  
)

export default component.exports